import type { ComponentProps } from "react";
import { t } from "ttag";

import { useMessenger } from "@/app/hooks/use-messenger";
import { Button, Dialog, HeartsIcon } from "@/shared/ui";

export const ErrorModal = ({
  open,
  onOpenChange,
}: ComponentProps<typeof Dialog.Root>) => {
  const {
    actions: { showMessenger },
  } = useMessenger();

  const handleContactSupport = () => {
    onOpenChange?.(false);
    showMessenger();
  };

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content>
        <Dialog.Header icon={HeartsIcon}>
          <Dialog.Title>{t`Oops seems like something went wrong`}</Dialog.Title>

          <Dialog.Description>
            {t`Please try again or reach out to support if this issue continue.`}
            <br />
            {t`Thank you for your patience!`}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button onClick={handleContactSupport} size="lg">
            {t`Contact support`}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
